import React from "react";
import cn from 'classnames';
import {withStore} from "game_play/utils/store";

import {Number} from '../utils'
import dartsIcon from '../../static/game/image/darts.svg';

class ScoreView extends React.Component {
  renderShot(ss) {
    if (ss?.score === undefined) return ''

    if (ss?.sectors) {
      return (
        <span className="info-score__score-current" style={{display: 'block'}}>
          {ss?.sectors.map((shot, i) => {
            return [i > 0 ? ' | ' : '', <Number value={shot[0] * shot[1]} key={i}/>]
          })}
        </span>
      )
    } else {
      return (
        <span className="info-score__score-current" style={{display: 'block'}}>
          <Number value={ss?.score}/>
        </span>
      )
    }
  }

  render() {
    const {Game} = this.props
    const {winner_number, start_time, end_time, score_1, score_2} = Game.get('game')
    const leg = Game.data
    const first = Game.first
    const is_gaming = start_time && !end_time
    const offsetSector = Game.offsetSectors()

    const [darts_1, darts_2] = Game.getDarts(leg)
    const [score_leg_1, score_leg_2] = Game.calculateScore(leg)
    const [, p] = Game.getSelected()
    const series = leg.at(-1)
    const series_prev = leg.at(-2)

    return (
      <div className="info-score">
        <div className="info-score__line">
          <div className="info-score__title">Leg</div>
          <div className="info-score__legs">
            <span className={cn('info-score__legs-first', {
              'hidden': first !== 0 || !is_gaming
            })}></span>
            <Number value={score_1} className={cn({
              'info-score__winner': winner_number === 1
            })}/>
            <span className="info-score__legs__separator">-</span>
            <Number value={score_2} className={cn({
              'info-score__winner': winner_number === 2
            })}/>
            <span className={cn('info-score__legs-first', {
              'hidden': first !== 1 || !is_gaming
            })}></span>
          </div>
        </div>
        {is_gaming && (
          <div className="info-score__line match__line-stats">
            <div className="info-score__title">Score</div>
            <div className="info-score__score">
              <div className="info-score__score-wrap">
                {is_gaming && series ? this.renderShot(series[0]) : is_gaming && series_prev && p !== 0 && this.renderShot(series_prev[0])}
                <Number value={score_leg_1} className={cn(
                  'info-score__score-lens', {
                  'info-score__score_play': is_gaming && p === 0,
                  'info-score__winner': winner_number === 1
                })}/>
                <span className="info-score__score__separator" style={{padding: '0 5px'}}>:</span>
                <Number value={score_leg_2} className={cn(
                  'info-score__score-lens', {
                  'info-score__score_play': is_gaming && p === 1,
                  'info-score__winner': winner_number === 2
                })}/>
                {is_gaming && series ? this.renderShot(series[1]) : is_gaming && series_prev && p !== 1 && this.renderShot(series_prev[1])}
              </div>
            </div>
          </div>
        )}
        {is_gaming && (
          <div className="info-score__line match__line-stats">
            <div className="info-score__title">
              {gettext('Сектор')} № 
              <br/>
            </div>
            <div className="info-score__title">
              <Number value={(leg.length || 1) + offsetSector}/>
              /
              <Number value={Game.maxSeries + offsetSector}/>
            </div>
          </div>
        )}
        {is_gaming && (
          <div className="info-score__line">
            <div className="info-score__title">Darts</div>
            <div className="info-score__darts">
              <Number value={darts_1}/>
              <img className="info-score__darts__image" src={dartsIcon} alt='darts' style={{padding: '0 5px'}}/>
              <Number value={darts_2}/>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStore(ScoreView)